const { OPEN_EDIT_EXP, CLOSE_EDIT_EXP, } = require("../types");

export const openEditExp = (exp) => dispatch => {
  dispatch({
    type: OPEN_EDIT_EXP,
    payload: exp
  })
};


export const closeEditExp = () => dispatch => {
  dispatch({
    type: CLOSE_EDIT_EXP
  })
};